<template>
    <header>
        <div class="ico mobile"><h4 class="on">{{this.current_lang.menu[4]}}</h4><h4>{{this.current_lang.menu[5]}}</h4></div>
        <div class="logo">
             <a :href="'../../'+this.langs+'/'" ><img alt="Villavela Hotel Boutique" src="../assets/images/logo.png"></a>
        </div>
        <div class="nav">
            <div>
                <router-link :to="'../../'+this.langs+'/'">{{this.current_lang.menu[0]}}</router-link>
                <router-link :to="'../../'+this.langs+'/rooms/single'">{{this.current_lang.menu[1]}}</router-link>
                <router-link :to="'../../'+this.langs+'/about'">{{this.current_lang.menu[2]}}</router-link>
                <a href="#contact" v-on:click="contactLink">{{this.current_lang.menu[3]}}</a>
            </div>
        </div>
        <Social></Social>
    </header>
</template>

<script>
// eslint-disable-next-line
import Social from '@/components/Social.vue'
import {mapState} from 'vuex';

export default {
    name: 'Header',
    components: {
        Social
    },
    data() {
        return {
            langs: null,
        }
    },
    computed: {
        ...mapState(['lang'])
    },
    created() {

        // lang

        var url =  window.location.href;

        url = url.split('/');

        url.forEach(element => {
           if(element === 'es'){
               this.langs = 'es';
           }else if(element === 'en'){
               this.langs = 'en';
           }
        });

        if(this.langs === null)
            this.langs = 'es';

        this.current_lang = this.lang.es;

        if(this.langs){
            if(this.langs === 'es'){
                this.current_lang = this.lang.es;
            }else if(this.langs === 'en'){
                this.current_lang = this.lang.en;
            }
        }

    },
    mounted() {
        $('header').on('click','.ico', function (e) {
            $(this).find('h4').each(function (index, element) {
                $(this).toggleClass('on');
            });

            $(this).parent().find('.nav').toggleClass('on');
        });

        $('header').find('.nav').on('click','a', function () {
            $('header').find('.ico').find('h4').each(function (index, element) {
                $(this).toggleClass('on');
            });

            $('header').find('.nav').toggleClass('on');
        });
    },
    methods: {
        contactLink(e){
            e.preventDefault();
            // eslint-disable-next-line
            $('html, body').animate({scrollTop: $('footer').offset().top}, 500)
        }
    },
}
</script>